module.exports = __webpack_public_path__ + "static/media/_special1.c4a0e640.jpg";